import { Wrapper } from './ErrorMessage.styles';

interface ErrorMessageType {
  className?: string;
  text: string;
  extraSpace?: boolean;
}

const ErrorMessage = ({
  className,
  text,
  extraSpace = false,
}: ErrorMessageType): JSX.Element => {
  return (
    <Wrapper extraSpace={extraSpace} className={className}>
      {text}
    </Wrapper>
  );
};

export default ErrorMessage;
